<cac-dialog-layout title="جزئیات گزارش" [hideControls]="!data.editable" (onSubmit)="onSubmit($event)">
  <div class="flex flex-wrap gap-x-8 gap-y-4 mt-2 mb-6">
    <app-image-viewer label="وضعیت سلامت" [imageUrl]="data.audit.propertyHealthStatusImageUrl"></app-image-viewer>
    <app-image-viewer label="وضعیت تگ" [imageUrl]="data.audit.tagStatusImageUrl"></app-image-viewer>
  </div>
  <cac-form-builder [options]="formBuilder"></cac-form-builder>
</cac-dialog-layout>